import { render, staticRenderFns } from "./Slide5.vue?vue&type=template&id=64ac2fa4&scoped=true&"
import script from "./Slide5.vue?vue&type=script&lang=js&"
export * from "./Slide5.vue?vue&type=script&lang=js&"
import style0 from "./Slide5.vue?vue&type=style&index=0&id=64ac2fa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ac2fa4",
  null
  
)

export default component.exports